import { render, staticRenderFns } from "./TicketTypeRadioItem.vue?vue&type=template&id=c588aac4&"
import script from "./TicketTypeRadioItem.vue?vue&type=script&lang=js&"
export * from "./TicketTypeRadioItem.vue?vue&type=script&lang=js&"
import style0 from "./TicketTypeRadioItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports